export default __webpack_public_path__ + "static/media/friendship.f9e05809.png";